import React, { useContext } from 'react';

import NumberFormat from 'react-number-format';
import { useNavigate } from 'react-router';

import Layout from '../components/common/Layout';
import { UserContext } from '../context/UserContext';

const Funded = () => {
  const navigate = useNavigate();
  const { appData } = useContext(UserContext);
  let approvedRateProperty = appData?.applicationFeatures?.find(
    (feature) => feature.itemType === 'ApprovedRateProperty'
  );
  let approveGrantAmount;
  if (approvedRateProperty) {
    approveGrantAmount = approvedRateProperty?.value?.finalApprovedAmount
      ? approvedRateProperty?.value?.approvedRate?.approvedAmount
      : null;
  } else {
    const multiRate = appData?.applicationFeatures?.find(
      (feature) => feature.itemType === 'MultiApprovedRateProperty'
    );

    if (multiRate && multiRate.value.rates.length > 0 && multiRate.value?.selectedIndex > 0) {
      approveGrantAmount =
        multiRate.value.rates[multiRate.value?.selectedIndex]?.approvedRate?.approvedAmount;
    }
  }

  return (
    <Layout>
      <div className="wait-list-page">
        <div className="page-inner">
          <h2>Grant Funded</h2>
          <div className="main-message">
            {approveGrantAmount && (
              <p>
                <b>Grant Amount:</b>{' '}
                <NumberFormat
                  value={approveGrantAmount}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={'$'}
                />
              </p>
            )}
            <p>
              <b>What it means:</b> We have received your signed grantee agreement and your funds
              have been released.
            </p>
            <p>
              <b>What you should do:</b> Check the bank account that you linked in the Portal for
              your grant award. It may take 3-5 business days for funds to appear.
            </p>
          </div>
          <button className="primary-btn" onClick={() => navigate('/dashboard')}>
            Return to Dashboard
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default Funded;
